import { VALIDATION, DATA_TYPE } from '../utils/validation';
import Consts from '../utils/constants';

export default {
    adcRequirements: {
        bits: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        type: {
            dataType: DATA_TYPE.STRING,
            valueSet: [Consts.ADC_TYPE.DIFF, Consts.ADC_TYPE.SE],
            validations: [VALIDATION.VALUE_SET]
        },
        deviceArchitecture: {
            dataType: DATA_TYPE.STRING,
            valueSet: [Consts.ARCHITECTURE.SAR, Consts.ARCHITECTURE.SIGMA_DELTA],
            validations: [VALIDATION.VALUE_SET]
        },
        defaultDriver: {
            dataType: DATA_TYPE.STRING,
            validations: [VALIDATION.DEFAULT_DRIVER]
        },
        maxSampleRate: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        acquisitionTimeMin: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        cadc: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        cpin: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        vrefTest: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        thdBaseline: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.BLANK_THD_TAB]
        },
        thdCorner: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.BLANK_THD_TAB]
        },
        thdSlope: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.BLANK_THD_TAB]
        },
        Cerror: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.BLANK_THD_TAB]
        },
        datasheetRfilt: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        datasheetCfilt: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        ADCSNR: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        freqMin: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.BLANK_THD_TAB]
        },
        freqMax: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.BLANK_THD_TAB]
        },
        vrefMax: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        kickbackType: {
            dataType: DATA_TYPE.STRING,
            valueSet: [Consts.KICKBACK_TYPE.FIXED, Consts.KICKBACK_TYPE.PREV_SAMPLE],
            validations: [VALIDATION.VALUE_SET]
        },
        kickbackVrefMultiplier: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        Vref_settlingTHDadj: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.SETTLING_THD_ADJ]
        },
        THD_settlingTHDadj: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.SETTLING_THD_ADJ]
        },
        fs_settlingTHDadj: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.SETTLING_THD_ADJ]
        },
        tacq_settlingTHDadj: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.SETTLING_THD_ADJ]
        },
        R_settlingTHDadj: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.SETTLING_THD_ADJ]
        },
        C_settlingTHDadj: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.SETTLING_THD_ADJ]
        },
        selectable: {
            dataType: DATA_TYPE.BOOLEAN,
            default: true,
            validations: [VALIDATION.DEFAULT]
        },
        blankTHDTab: {
            dataType: DATA_TYPE.BOOLEAN,
            default: false,
            validations: [VALIDATION.DEFAULT]
        },
        settlingTHDadj: {
            dataType: DATA_TYPE.BOOLEAN,
            default: false,
            validations: [VALIDATION.DEFAULT]
        },
        recommendedDrivers: {
            validations: [VALIDATION.RECOMMENDED_DRIVERS]
        }
    },

    driverRequirements: {
        type: {
            dataType: DATA_TYPE.STRING,
            valueSet: [Consts.DRIVER_TYPE.AMP, Consts.DRIVER_TYPE.DIFF_AMP],
            validations: [VALIDATION.VALUE_SET]
        },
        vn: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        inp: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        inn: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        slewRate: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        is: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        HD2flatTEMP: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        HD3flatTEMP: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        HD2slopeTEMP: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        HD3slopeTEMP: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        HD2cornerTEMP: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        HD3cornerTEMP: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        unityGain: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        GBWP: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        Ro: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        VsMin: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        VsMax: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        rfDefault: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        rfLowerWarning: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        rfLowerLimit: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        rfiltMin: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        VinHdrmNeg: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        VinHdrmPos: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        VoutHdrmNeg: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        VoutHdrmPos: {
            dataType: DATA_TYPE.NUMBER,
            validations: [VALIDATION.REQUIRED]
        },
        IoutSC: {
            dataType: DATA_TYPE.NUMBER,
            alternates: ['IoutLinear'],
            validations: [VALIDATION.ALTERNATE]
        },
        selectable: {
            dataType: DATA_TYPE.BOOLEAN,
            default: true,
            validations: [VALIDATION.DEFAULT]
        },
        fixedGain: {
            dataType: DATA_TYPE.NUMBER,
            default: null,
            validations: [VALIDATION.DEFAULT]
        }
    }
}